import Page from '../page';
import SnackableNavigation from '../navigation/snackable-navigation';

import DailyJourney from '../pages/components/daily-journey.vue';
import YesNoQuestion from '../pages/components/yes-no-question.vue';
import SingleFieldPrompt from '../pages/components/single-field-prompt.vue';
import MakeCommitment from '../pages/components/make-commitment.vue';
import Quiz from '../pages/components/quiz.vue';
import QuizScoring from '../pages/components/quiz-scoring.vue';
import QuizPersonalised from '../pages/components/quiz-personalised.vue';
import QuizDiscussinGuide from '../components/snackable/quiz-discussion-guide.vue';
import SymptomChecker from '../components/snackable/symptom-checker.vue';
import Listicle from '../pages/components/listicle.vue';
import Poll from '../pages/components/poll.vue';

const SnackablePages = [
    {
        path: '/snackable',
        // You could also have named views at the top
        components: {
            default: Page,
            'sidebar-nav': SnackableNavigation
        },
        children: [
            {
                path: '',
                redirect: 'daily-journey'
            },
            {
                path: 'daily-journey',
                component: DailyJourney
            },
            {
                path: 'yes-no-question',
                component: YesNoQuestion
            },
            {
                path: 'single-field-prompt',
                component: SingleFieldPrompt
            },
            {
                path: 'make-commitment',
                component: MakeCommitment
            },
            {
                path: 'quiz',
                component: Quiz
            },
            {
                path: 'quiz-scoring',
                component: QuizScoring
            },
            {
                path: 'quiz-personalised',
                component: QuizPersonalised
            },
            {
                path: 'quiz-discussion-guide',
                component: QuizDiscussinGuide
            },
            {
                path: 'symptom-checker',
                component: SymptomChecker
            },
            {
                path: 'listicle',
                component: Listicle
            },
            {
                path: 'poll',
                component: Poll
            }
        ]
    }
];

export default SnackablePages;



// WEBPACK FOOTER //
// ./demo/routes/snackables.js